import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Input } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { Field } from "./../../../Order/Field/Field";
import Files from "./Files/Files";
import style from "./../Items.module.scss";
import { FormattedDate } from "react-intl";
import { showToast } from "../../../../../utils/Helper";

const NewPost = ({ alertId, readonly, user, status, fetchs, dispatch, processes, enabledAlertFeatures }) => {
  const [loading, setLoading] = React.useState(false);
  const [changingStatus, setChangingStatus] = React.useState(false);
  const [description, setDescription] = React.useState("");
  const [files, setFiles] = React.useState([]);
  const [errors, setErrors] = React.useState({});
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showFeatures, setShowEnabledFeatures] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Actualiza la fecha cada segundo

    return () => clearInterval(interval); // Limpia el intervalo cuando el componente se desmonta
  }, []);

  const handleFilesUpload = (event) => {
    const addedFiles = Object.values(event.target.files);

    // filter files that its name length is more  than 200 characters including the extension
    const reservedCharsRegex = /[!@#$%^&*()+={}\[\]|\\:;"'<>,?/]/;

    const validFiles = addedFiles.filter((f) => {
      const isTooLong = f.name.length >= 200;
      const hasReservedChars = reservedCharsRegex.test(f.name);
      
      return !isTooLong && !hasReservedChars;
    });

      if (validFiles.length !== addedFiles.length) {
        showToast(
        "Some files were not added because their names are too long or contain invalid characters (e.g., %, /, +, #, etc.).",
        true
      );
    }
    
    setFiles([
      ...validFiles.map((f) => ({
        id: Math.random().toString(36).substring(2, 15),
        name: f.name,
        type: f.type,
        data: f,
      })),
    ]);
  };

  const deleteFile = (id) => {
    setFiles(files.filter((f) => f.id != id));
  };
  
  const readFileAsBase64 = (file) =>
    new Promise(function (resolve, reject) {
      var r = new FileReader();
      r.onload = function () {
        var result = String(r.result || "");
        var parts = result.split(",");
        resolve(parts.length > 1 ? parts[1] : "");
      };
      r.onerror = reject;
      r.readAsDataURL(file);
    });

  const buildAlertFilesPayload = async function (files) {
    var items = await Promise.all(
      files.map(async function (f) {
        var content = await readFileAsBase64(f.data);
        var name = f.name || "";
        var parts = name.split(".");
        var ext = "";
        if (parts.length > 1) {
          ext = parts.pop().trim();
          if (ext.charAt(0) === ".") ext = ext.substring(1);
        }
        var fileNameOnly = parts.join(".");
        return { fileName: fileNameOnly, extension: ext, content: content };
      })
    );
    return items;
    };    

    useEffect(() => {
      if ((enabledAlertFeatures))
        if (enabledAlertFeatures.AlertFlowEnabled)
          setShowEnabledFeatures((enabledAlertFeatures.AlertType.some((f) => 
          f.AlertTypeInternalName === processes && !f.AlertTypeEnabled)));
        else
          setShowEnabledFeatures(true);
      else setShowEnabledFeatures(true);
    }, [alertId]);

    const addToHistory = function () {
      if (!description) {
        setErrors(function (e) { return Object.assign({}, e, { description: "Required Field" }); });
        return;
      }
    
      setLoading(true);
    
      var getLocalISOTime = function () {
        var date = new Date();
        var tzOffset = -date.getTimezoneOffset() * 60 * 1000;
        var localDate = new Date(date.getTime() + tzOffset);
        return localDate.toISOString().slice(0, -1);
      };
    
      // crear history (sin archivos)
      fetchs.addToHistory(
        {
          eventId: alertId,
          message: description,
          dateTime: getLocalISOTime()
        },
        async function (resp) {
          try {
            var historyEventId = resp.historyEventId
            if (!historyEventId) throw new Error("No llegó historyEventId en la respuesta de addToHistory.");
    
            // si no hay archivos, terminar
          if (!files || files.length === 0) {
            fetchs.alert(alertId);
            setLoading(false);
            setFiles([]);
            setDescription("");
            return;
          }
  
          // subir archivos
          const filesPayload = await buildAlertFilesPayload(files);
          fetchs.uploadFile(
            {
              eventId: alertId,
              historyEventId: historyEventId,
              files: filesPayload
            },
            function (_resp2) {
              fetchs.alert(alertId);
              setLoading(false);
              setFiles([]);
              setDescription("");
            }
          );
        } catch (err) {
          console.error("addToHistory/uploadFile error:", err);
          setLoading(false);
          setErrors(function (e) { return Object.assign({}, e, { files: "Error uploading files. Please try again." }); });
        }
        }
      );
    };    

  const changeWorkingStatus = () => {
    let nextStatus = "WorkingAdvisor";

    if (user.role == "Advisor") {
      nextStatus = "WorkingCompliance";
    }

    setChangingStatus(true);

    fetchs.updateStatus(
      {
        eventId: alertId,
        statusCompliance: nextStatus,
      },
      (response) => {
        dispatch({ type: "ALERT_UPDATE", alert: { status: nextStatus } });
        setChangingStatus(false);
        fetchs.updateGrid(alertId);
      }
    );

    {
      user.role == "Advisor" ? "Compliance" : "Advisor";
    }
  };

  const sendToCEO = () => {
    let nextStatus = "WorkingCEO";

    if (status == "WorkingCEO") {
      nextStatus = "WorkingCompliance";
    }

    setChangingStatus(true);

    fetchs.updateStatus(
      {
        eventId: alertId,
        statusCompliance: nextStatus,
      },
      (response) => {
        dispatch({ type: "ALERT_UPDATE", alert: { status: nextStatus } });
        setChangingStatus(false);
      }
    );
  };

  if (readonly) {
    return null;
  }

  return (
    <div className={style.newpost}>
      <Container>
        <Row>
          <Col lg={5}>
            <span className={style.user}>{user.name}</span>
            <small>
              <FormattedDate value={new Date()} />
            </small>
          </Col>
          {processes != "ExternalImport" && processes != "RiskChanges" && (
            <Col lg={7}>
              {((user.role == "Advisor" && status == "WorkingAdvisor") ||
                (user.role == "Compliance" && status == "WorkingCompliance")) && (showFeatures) &&(
                <LaddaButton
                  className={"btn btn-ladda btn-primary btn-sm"}
                  style={{ float: "right" }}
                  loading={changingStatus}
                  onClick={() => changeWorkingStatus()}
                  data-style={EXPAND_RIGHT}
                >
                  <i className="fa fa-paper-plane" aria-hidden="true"></i> Send to{" "}
                  {user.role == "Advisor" ? "Compliance" : "Advisor"}
                </LaddaButton>
              )}
            </Col>
          )}
        </Row>
        <div> </div>
        {processes === "TransactionalLimit" || processes === "RiskChanges" ? (
          <Row>
            <Col lg={12}>
              {((user.role == "CEO" && status == "WorkingCEO" && processes != "RiskChanges") ||
                (user.role == "Compliance" && status == "WorkingCompliance")) && (showFeatures) && (
                <LaddaButton
                  className={"btn btn-ladda btn-primary btn-sm"}
                  style={{ float: "right" }}
                  loading={changingStatus}
                  onClick={() => sendToCEO()}
                  data-style={EXPAND_RIGHT}
                >
                  <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  {status == "WorkingCompliance" ? "Second Approval" : "Send to Compliance"}
                </LaddaButton>
              )}
            </Col>
          </Row>
        ) : ("")}

        <Row>
          <Col lg={12}>
            <Field label={"Description"} error={errors.description}>
            <Input
                type={"textarea"}
                rows={2}
                placeholder={"Description"}
                value={description}
                disabled={readonly || loading}
                invalid={!!errors.description || description.length > 5000}
                style={description.length > 5000 ? { borderColor: "red" } : {}}
                onChange={(e) => {
                  if (e.target.value.length <= 5000) {
                    setDescription(e.target.value);
                    if (e.target.value !== "") {
                      setErrors({ ...errors, description: undefined });
                    }
                  } else {
                    setErrors({ ...errors, description: "Max Characters Limit Reached" });
                  }
                }}
              />
            </Field>

            <Files files={files} deleteFile={deleteFile} />

            <div className="mt-2 mb-2 text-right">
              <Button color="primary btn btn-sm" style={{ float: "left", position: "relative" }}>
                <i className="fa fa-upload mr-2"></i>
                <input
                  type="file"
                  className={style.inputFile}
                  multiple
                  onChange={(e) => handleFilesUpload(e)}
                />
                Upload files
              </Button>
              <Button
                color="light btn-sm"
                onClick={() => {
                  setFiles([]);
                  setDescription("");
                  setErrors({});
                }}
              >
                Discard
              </Button>{" "}
              <LaddaButton
                className={"btn btn-ladda btn-primary btn-sm"}
                loading={loading}
                onClick={() => addToHistory()}
                data-style={EXPAND_RIGHT}
              >
                Add
              </LaddaButton>
              <br />
              <span className={style.error}>
                {errors.files ? errors.files : ""}
                {description.length > 5000 ? "Max Characters Limit Reached" : ""}
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewPost;